var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zhCN}},[(_vm.isRouteReady)?_c('div',[(
          !_vm.showCmsList.includes(_vm.$route.path) &&
          !_vm.$route.path.includes('myself') &&
          _vm.$route.path !== '/' &&
          _vm.$route.path !== '/login'
        )?_c('HeaderTotal'):_vm._e(),(
          _vm.$route.path.indexOf('myself') !== -1 ||
          _vm.$route.path === '/' ||
          _vm.showCmsList.includes(_vm.$route.path)
        )?_c('CmsHeader',{attrs:{"name":_vm.$route.path.indexOf('myself') !== -1
            ? (_vm.name = '用户中心')
            : (_vm.name = '政策服务')}}):_vm._e(),_c('router-view'),(
          !_vm.showCmsList.includes(_vm.$route.path) &&
          !_vm.$route.path.includes('myself') &&
          _vm.$route.path !== '/' &&
          _vm.$route.path !== '/login'
        )?_c('FooterTatal'):_vm._e(),(
          _vm.showCmsList.includes(_vm.$route.path) ||
          _vm.$route.path === '/' ||
          _vm.$route.path.includes('myself')
        )?_c('CmsFooter'):_vm._e()],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }